import { computed, inject, Injectable, signal } from '@angular/core';
import { ListingPageModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { ListingPageModelAbstract } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model-abstract';
import { ListingTableComponent } from 'src/app/shared/components/listing-table/listing-table.component';
import { ListingPageId } from '@portal/shared/components/listing-page/store/listing-page-store.types';
import { ListingPageModelRegistry } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model-registry.service';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { DeviceHistoryFieldName } from '../services/history-api.types';
import { HistoryLogListingFiltersSourceService } from './history-log-listing-filters-source.service';
import { HistoryLogListingDataSourceService } from './history-log-listing-data-source.service';
import { HistoryLogListingExportConfigService } from './history-log-listing-export-config.service';
import { createHistoryLogColumns } from './history-log-listing.columns';
import { HISTORY_LOG_DEFAULT_SEARCH_TYPE, HISTORY_LOG_SEARCH_TYPES } from './history-log-listing.search';
import { HISTORY_LOG_SORT_FIELD } from './history-log-listing.sort';

@Injectable()
export class HistoryLogListingModelService extends ListingPageModelAbstract implements ListingPageModel {
  readonly listingPageModelRegistry = inject(ListingPageModelRegistry);

  readonly pageTitle = TranslateRegistry.get.HISTORY_LOG.TITLE.HISTORY_LOG;
  readonly searchTypeList = signal(HISTORY_LOG_SEARCH_TYPES);
  readonly selectedSearchType = signal(HISTORY_LOG_DEFAULT_SEARCH_TYPE);
  readonly sorting = signal({
    columnName: DeviceHistoryFieldName.DateTimeUtcSet,
    orderDirection: OrderDirection.DESC
  });
  readonly tableColumns = computed(() => createHistoryLogColumns());
  readonly filterSource = inject(HistoryLogListingFiltersSourceService);
  readonly dataSource = inject(HistoryLogListingDataSourceService);
  readonly exportConfig = inject(HistoryLogListingExportConfigService);

  readonly tableCmp = ListingTableComponent;
  readonly sortField = HISTORY_LOG_SORT_FIELD;

  get pageId(): ListingPageId {
    return ListingPageId.HistoryLog;
  }

  constructor() {
    super();
    this.listingPageModelRegistry.add(ListingPageId.HistoryLog, this);
  }
}
